import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-logo-header',
  standalone: true,
  templateUrl: './logo-header.component.html',
  styleUrls: ['./logo-header.component.scss'],
  imports: [CommonModule]
})
export class LogoHeaderComponent {
  @Input() logoUrl = '';
  @Input() altText = '';
}
